import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import * as Sentry from '@sentry/react';
import { noop } from 'lodash-es';
import { useStateInRef, useTransaction } from 'seagull';
import { useIoContext, useStore, useStoreStatic } from "../contexts";
import { useRootDevice } from "../providers/DeviceProvider";
import { selectors } from "../store/state-selectors";
import { jsx as _jsx } from "react/jsx-runtime";
const IntercomStarterContext = /*#__PURE__*/createContext({
  setEnableIntercom: noop
});
export const useIntercomStarter = () => useContext(IntercomStarterContext);
export function IntercomStarter(_ref) {
  let {
    children
  } = _ref;
  const userInfo = useStore(state => state.userInfo);
  const {
    getState
  } = useStoreStatic();
  const isRealUser = useStore(selectors.isRealUser);
  const {
    intercomClient
  } = useIoContext();
  const rootDevice = useRootDevice();
  const getRootDevice = useStateInRef(rootDevice);
  const [enableIntercom, setEnableIntercom] = useState(false);
  const value = useMemo(() => ({
    setEnableIntercom
  }), []);
  const userEmail = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email()) || '';
  const userId = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id()) || '';
  const startTransaction = useTransaction();
  useEffect(() => {
    if (isRealUser && enableIntercom) {
      const userHash = selectors.intercomUserHash(getState());
      const hideDefaultLauncher = getRootDevice().isMobileDevice;
      if (!userHash) {
        Sentry.captureMessage('Intercom boot without user_hash', {
          level: 'warning',
          tags: {
            context: 'intercom_missing_user_hash'
          },
          extra: {
            userId,
            userEmail
          }
        });
      }
      intercomClient.boot({
        app_id: window._intercom_app_id,
        email: userEmail,
        user_id: userId,
        created_at: Date.now(),
        user_hash: userHash || undefined,
        hide_default_launcher: hideDefaultLauncher
      });
    } else {
      intercomClient.shutdown();
    }
  }, [userEmail, userId, isRealUser, enableIntercom, startTransaction]);
  return /*#__PURE__*/_jsx(IntercomStarterContext.Provider, {
    value: value,
    children: children
  });
}